import { css } from '@emotion/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { LayoutBand, Skeleton, useContainerWidth, Separator, FlowGrid } from '@fs/zion-ui'

// zion-ui marks every Skeleton element aria-hidden, so the loading state needs its own
// announcement. <output> carries an implicit role="status" live region, and it sits outside
// the aria-busy subtree: inside it, assistive tech withholds the message until busy clears,
// which never happens because the fallback unmounts.
const visuallyHidden = css`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const TreeOverviewPageSkeleton = () => {
  const atWidth = useContainerWidth()
  const { t } = useTranslation()

  return (
    <>
      <output css={visuallyHidden}>{t('tree-overview.page.loading.label', 'Loading')}</output>

      <div aria-busy="true">
        <LayoutBand>
          <Separator size="xxl" />
          <FlowGrid columnCount={atWidth({ md: 2 })}>
            <div>
              <Separator size="xxl" />
              <Skeleton.Image height={300} />
              <Separator size="xxl" />
            </div>
            <Skeleton.Image height={600} />
          </FlowGrid>
          <Separator />
          <FlowGrid columnCount={atWidth({ md: 4 })}>
            <Skeleton.Image height={375} />
            <Skeleton.Image height={375} />
            <Skeleton.Image height={375} />
            <Skeleton.Image height={375} />
          </FlowGrid>
        </LayoutBand>
      </div>
    </>
  )
}

export default TreeOverviewPageSkeleton
